import React, { useState, useCallback, Suspense, lazy } from 'react'
import CustomHeader from '../../components/CustomHeader'
import PAGE_TITLES from '../../consts/titles'
import { Box } from '@mui/material'
import PageHeader from '../../components/PageHeader'
import GenericButton from '../../components/GenericButton'
import { ButtonType } from '../../components/GenericButton/styles'
import GenericModal from '../../components/GenericModal'
import CreateAndEditProject from '../../features/DistributionSeriesAndPlan/Projects/CreateAndEditProject'
import { useQuery } from '@tanstack/react-query'
import { type IDistributionSeries } from '../../models/DistributionSeries'
import { DistributionManager } from '../../APIManager'
import LoadingPageV2 from '../LoadingPageV2'
import { ProjectsSidebar } from '../../features/DistributionSeriesAndPlan/Projects/ProjectsSidebar'
import { DistributionPlanTable } from '../../features/DistributionSeriesAndPlan/DistributionPlanTable'
import { type CustomBreadcrumbT } from '../../utils/BreadcrumbDataPreparation'
import ROUTES from '../../consts/paths'

const DistributionSeriesPage: React.FC = () => {
  const [openModal, setOpenModal] = useState<boolean>(false)

  const {
    data: projects = [],
    isLoading: isProjectsLoading
  } = useQuery<IDistributionSeries[]>({
    queryKey: ['projects'],
    queryFn: async () => (await DistributionManager.getAllDistributionSeries()).data,
    retry: false,
    enabled: true,
    refetchOnMount: false
  })

  const handleOpenModal = useCallback(() => { setOpenModal(true) }, [])
  const handleCloseModal = useCallback(() => { setOpenModal(false) }, [])

  const isLoading = isProjectsLoading
  const breadcrumbPrefixList: CustomBreadcrumbT[] = [{ title: PAGE_TITLES.DISTRIBUTION_SERIES, path: ROUTES.DISTRIBUTION_SERIES }]

  return (
    <Box width="100%" display='flex' flexDirection='column' gap={6}>
      <CustomHeader title={PAGE_TITLES.DISTRIBUTION_SERIES} />
      <PageHeader
        title={PAGE_TITLES.DISTRIBUTION_SERIES}
        description='All your survey projects are listed below'
        isCollapsible={false}
        breadcrumb={breadcrumbPrefixList}
        controls={
          <GenericButton
            buttonType={ButtonType.Primary}
            label="Create Project"
            sx={{ whiteSpace: 'nowrap' }}
            onClick={handleOpenModal}
          />
        }
      />

      {
        isLoading
          ? <LoadingPageV2 title={PAGE_TITLES.DISTRIBUTION_SERIES} />
          : <Box display="flex" gap={8} width="100%">
              <Box width="20%" height={'72vh'} overflow="auto" >
                <ProjectsSidebar projects={projects} />
              </Box>
              <Box width="80%">
                <DistributionPlanTable />
              </Box>
            </Box>
      }

      <GenericModal
        isOpen={openModal}
        maxWidth="sm"
        title="Create Survey Project"
        onClose={handleCloseModal}
        action={false}
      >
        <CreateAndEditProject handleCloseModal={handleCloseModal} />
      </GenericModal>
    </Box>
  )
}

export default DistributionSeriesPage
